<div class="se-dialog">
    <div class="se-dialog-holder">
        <div class="se-complex-header">
            <h3 class="se-dialiog-title">{{labels.requestAccess}}</h3>
        </div>
        <div class="se-dialog-body">
            <p class="font-weight-bold">{{labels.requestSubLabel}}<span class="colorRed">*</span></p>
            <p>{{labels.requestSecondLabel}}</p>
            <div class="se-block-form">
                <div class="form-ele">
                    <textarea [ngClass]="{'red-border-class': isValid == false}" class="se-form-control" placeholder="{{labels.typeHere}}" [(ngModel)]="data.textVal" cdkFocusInitial maxlength="150"></textarea>
                    <div class="error" *ngIf="!isValid">
                        {{labels.enterDescription}}
                    </div>
                </div>
            </div>
        </div>
        <div class="se-dialog-footer">
            <button class="se-button" [mat-dialog-close]="false">{{labels.cancel}}</button>
            <button class="se-button button-primary" (click)="confirmBtn(data)">{{labels.confirm}}</button>
        </div>
    </div>
</div>